/**
 * API de Salas
 * - Lista salas del usuario
 * - Obtiene sala concreta
 * - Crea sala
 * - Edita sala
 * - Elimina sala
 */

import api from "./axios";

/**
 * Obtiene todas las salas del usuario
 */
export const obtenerSalasDelUsuario = async () => {
    const { data } = await api.get("/salas/usuario");
    return data;
};

/**
 * Obtiene una sala concreta con sus listas
 */
export const obtenerSala = async (idSala) => {
    const { data } = await api.get(`/salas/${idSala}`);
    return data;
};

/**
 * Crea una nueva sala
 */
export const crearSala = async (payload) => {
    const { data } = await api.post("/salas", payload);
    return data;
};

/**
 * Edita una sala existente
 */
export const editarSala = async (idSala, payload) => {
    const { data } = await api.put(`/salas/${idSala}`, payload);
    return data;
};

/**
 * Elimina una sala
 */
export const eliminarSala = async (idSala) => {
    await api.delete(`/salas/${idSala}`);
};
